import React, { useEffect, useState } from 'react'

import { Skeleton } from 'antd'

import {
  BenefitLegalDocumentsState,
  legalDocumentsStateApi,
} from 'core/application/adminDashboard/legalDocuments/benefitPlanDocuments'

import Empty from './Empty'
import Summary from './Summary'

import './ViewDocumentsStyles.less'

const LegalDocuments: React.FC = () => {
  // const [legalDocumentsState, setLegalDocumentsState] = useState<BenefitLegalDocumentsState | undefined>(undefined);

  // useEffect(() => {
  //   legalDocumentsStateApi().then((response: BenefitLegalDocumentsState) => {
  //     setLegalDocumentsState(response);
  //   });
  // }, []);

  return (
    // <Skeleton active loading={legalDocumentsState === undefined} paragraph={{ rows: 10 }}>
    //   {legalDocumentsState !== undefined ? legalDocumentsState.signed ? <Summary /> : <Empty /> : null}
    // </Skeleton>
    <Summary />
  )
}

export default LegalDocuments
